import { render } from "./User-select.vue?vue&type=template&id=58094668"
import script from "./User-select.vue?vue&type=script&lang=js"
export * from "./User-select.vue?vue&type=script&lang=js"

import "./User-select.vue?vue&type=style&index=0&id=58094668&lang=css"

import exportComponent from "/Users/thomas/Desktop/CNT/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__